export default __webpack_public_path__ + "static/media/gallery-wip-emitter_01.b2491dd7.jpg";